import { render, staticRenderFns } from "./AccountsList.vue?vue&type=template&id=4f4aed1a&scoped=true"
import script from "./AccountsList.vue?vue&type=script&lang=js"
export * from "./AccountsList.vue?vue&type=script&lang=js"
import style0 from "./AccountsList.vue?vue&type=style&index=0&id=4f4aed1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4aed1a",
  null
  
)

export default component.exports